import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import CompetitorReferencesList from './CompetitorReferencesList'

export default function CompetitorReferences() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/competitor_references" component={CompetitorReferencesList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}